import React from "react";
// nodejs library that concatenates classes
import classnames from "classnames";
// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Row,
  Col,
  Button
} from "reactstrap";
// core components
import { saveAdvision } from '../../../actions/advisionActions';
import connect from 'redux-connect-decorator';
import { AvForm, AvField, AvGroup, AvInput } from 'availity-reactstrap-validation';

@connect(
  state => ({
    advision: state.advision.advision
  }),
  {
    saveAdvision
  }
)
class AdviceForm extends React.Component<any, any> {
  state = {
    fullname: null,
    email: null,
    address: null,
    phonenumber: null,
    note: null
  };
  
  componentDidMount() {
  }

  handleSubmit = (event, errors, data) => {
    console.log(`advision ${data} `);
    // handleLogin(username, password, rememberMe);
    this.props.saveAdvision(data);
  };
  
  render() {
    return (
      <>
        <Card>
          <CardHeader>
            <h3 className="mb-0">ĐĂNG KÍ NHẬN TƯ VẤN & THAM GIA TRIAL CLASS</h3>
          </CardHeader>
          <CardBody>
            <AvForm role="form" onSubmit={this.handleSubmit}>
              <Form>
                <Row>
                  <Col md="6">
                    <FormGroup>
                        <AvField
                          name="fullname"
                          placeholder="Fullname"
                          type="text"
                          className="form-control-sm"
                          validate={{
                            required: { value: true, errorMessage: "Your fullname is required." },
                            minLength: { value: 3, errorMessage: "Your fullname is required to be at least 3 characters." }
                          }}
                        />
                      </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <AvField
                        name="email"
                        placeholder="Email"
                        type="email"
                        className="form-control-sm"
                        validate={{
                          required: { value: true, errorMessage: "Your email is required." },
                          minLength: { value: 5, errorMessage: "Your email is required to be at least 5 characters." },
                          maxLength: { value: 50, errorMessage: "Your email cannot be longer than 50 characters." }
                        }}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md="6">
                    <FormGroup>
                        <AvField
                          name="address"
                          placeholder="Location"
                          type="text"
                          className="form-control-sm"
                        />
                      </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <AvField
                          name="phonenumber"
                          placeholder="Phone number"
                          type="text"
                          className="form-control-sm"
                          validate={{
                            required: { value: true, errorMessage: "Your phonenumber is required." },
                            minLength: { value: 8, errorMessage: "Your phonenumber is required to be at least 8 characters." },
                            maxLength: { value: 12, errorMessage: "Your phonenumber cannot be longer than 12 characters." }
                          }}
                        />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md="12">
                    <FormGroup>
                      <AvInput type="textarea" name="note" id="note" placeholder="Note" />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <div className="text-center" style={{margin: 'auto'}}>
                    <Button className="my-4" color="info" type="submit">
                      Đăng ký tư vấn
                    </Button>
                  </div>
                </Row>
              </Form>
            </AvForm>
          </CardBody>
        </Card>
      </>
    );
  }
}
export default AdviceForm;
